import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { handleApiError } from '../../utils/handleApiError';
import Cookie from "cookie-universal";

// const baseUrl = "http://localhost:5000/api/products";
const baseUrl = `${process.env.REACT_APP_API_URL}/products`;
const cookie = Cookie();
export const fetchProducts = createAsyncThunk(
  'products/fetchProducts',
  async ({ endPoint, page }, { rejectWithValue }) => {
    try {
      const fullUrl = endPoint.includes('?')
        ? `${baseUrl}/${endPoint}&page=${page}&limit=10`
        : `${baseUrl}/${endPoint}?page=${page}&limit=10`;

      const res = await axios.get(fullUrl, {
        headers: {
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjY3OTY1M2ZjOGNhYTcyNDc2YjEwYjlmNCIsInJvbGUiOiJVc2VyIiwiaWF0IjoxNzM3OTA1MTQ4fQ.sMgFnT8UEN-arsr6v5SJdsY_JYESWY__fx0KRkYrdb4',
        },
      });

      return res.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, "backendProductErrors");
    }
  }
);

export const fetchBrandProducts = createAsyncThunk(
  'products/fetchBrandProducts',
  async (brandName, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseUrl}/brand-products?brand=${brandName}&page=1&limit=10`,
        {
          headers: {
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjY3OTY1M2ZjOGNhYTcyNDc2YjEwYjlmNCIsInJvbGUiOiJVc2VyIiwiaWF0IjoxNzM3OTA1MTQ4fQ.sMgFnT8UEN-arsr6v5SJdsY_JYESWY__fx0KRkYrdb4',
          },
        }
      );
      return res.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, "backendProductErrors");
    }
  }
);

export const fetchCategoryProducts = createAsyncThunk(
  "product/fetchCategoryProducts",
  async (category, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseUrl}/category/${category}`, {
        headers: {
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjY3OTY1M2ZjOGNhYTcyNDc2YjEwYjlmNCIsInJvbGUiOiJVc2VyIiwiaWF0IjoxNzM3OTA1MTQ4fQ.sMgFnT8UEN-arsr6v5SJdsY_JYESWY__fx0KRkYrdb4',
        },
      });
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, "backendProductErrors");
    }
  }
);


export const filterProducts = createAsyncThunk(
  'products/filterProducts',
  async ({ filters, page }, { rejectWithValue }) => {
    try {
      // const queryParams = new URLSearchParams({
      //   isNewArrival: filters.isNewArrival,
      //   isTrending: filters.isTrending,
      //   brand: filters.brand,
      //   category: filters.category,
      //   typeOfProuct: filters.typeOfProuct,
      //   minPrice: filters.price[0],
      //   maxPrice: filters.price[1],
      //   colors: filters.color,
      //   sizes: filters.size,
      //   page,
      //   limit: 10,
      // }).toString();

      const params = {
        page,
        limit: 10,
        minPrice: filters.price[0],
        maxPrice: filters.price[1],
      };

      if (filters.isNewArrival !== undefined) params.isNewArrival = filters.isNewArrival;
      if (filters.isTrending !== undefined) params.isTrending = filters.isTrending;
      if (filters.brand) params.brand = filters.brand;
      if (filters.category) params.category = filters.category;
      if (filters.typeOfProuct) params.typeOfProuct = filters.typeOfProuct;
      if (filters.color) params.colors = filters.color;
      if (filters.size) params.sizes = filters.size;

      const queryParams = new URLSearchParams(params).toString();

      const res = await axios.post(
        `${baseUrl}/filter-products?${queryParams}`,
        {},
        {
          headers: {
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjY3OTY1M2ZjOGNhYTcyNDc2YjEwYjlmNCIsInJvbGUiOiJVc2VyIiwiaWF0IjoxNzM3OTA1MTQ4fQ.sMgFnT8UEN-arsr6v5SJdsY_JYESWY__fx0KRkYrdb4',
          },
        }
      );
      return res.data;

    } catch (error) {
      return handleApiError(error, rejectWithValue, "backendProductErrors");
    }
  }
);

export const fetchProductById = createAsyncThunk(
  "product/fetchById",
  async (productId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${baseUrl}/get-product/${productId}`, {
        headers: {
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjY3OTY1M2ZjOGNhYTcyNDc2YjEwYjlmNCIsInJvbGUiOiJVc2VyIiwiaWF0IjoxNzM3OTA1MTQ4fQ.sMgFnT8UEN-arsr6v5SJdsY_JYESWY__fx0KRkYrdb4',
        }
      });
      return res.data;
    } catch (error) {

      if (!error.response) {
        return rejectWithValue({ networkError: "Network error. Please check your connection." })
      }

      if (error.response?.data.message === "product is not found") {
        return rejectWithValue({
          backendProductErrors: {
            message: error.response.data.message
          }
        })
      }

      else if (error.response?.data.message === "something went wrong.") {
        return rejectWithValue({
          serverError: "server error, try again later."
        })
      }

      else {
        return rejectWithValue({ unknownError: "An unknown error occurred." })
      }
    }
  }
);

export const getAllReviews = createAsyncThunk(
  "product/getAllReviews",
  async (productId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${baseUrl}/reviews/${productId}`, {
        headers: {
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjY3OTY1M2ZjOGNhYTcyNDc2YjEwYjlmNCIsInJvbGUiOiJVc2VyIiwiaWF0IjoxNzM3OTA1MTQ4fQ.sMgFnT8UEN-arsr6v5SJdsY_JYESWY__fx0KRkYrdb4',
        }
      });
      return res.data.reviews;
    } catch (error) {
      if (!error.response) {
        return rejectWithValue({ networkError: "Network error. Please check your connection." })
      }

      if (error.response?.data.message === "product not found") {
        return rejectWithValue({
          backendProductErrors: {
            message: error.response.data.message
          }
        })
      }

      else if (error.response?.data.message === "something went wrong.") {
        return rejectWithValue({ serverError: "server error, try again later." })
      }

      else {
        return rejectWithValue({ unknownError: "An unknown error occurred." })
      }
    }
  }
)

export const addRating = createAsyncThunk(
  "product/addRating",
  async ({ productId, ratingForm }, { rejectWithValue }) => {
    try {
      const userId = cookie.get("userId");
      const res = await axios.post(`${baseUrl}/add-rating?userId=${userId}?productId=${productId}`, ratingForm, {
        headers: {
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjY3OTY1M2ZjOGNhYTcyNDc2YjEwYjlmNCIsInJvbGUiOiJVc2VyIiwiaWF0IjoxNzM3OTA1MTQ4fQ.sMgFnT8UEN-arsr6v5SJdsY_JYESWY__fx0KRkYrdb4',
        }
      })

      return { rating: res.data.rating };
    } catch (error) {
      if (!error.response) {
        return rejectWithValue({ networkError: "Network error. Please check your connection." })
      }

      if (error.response?.data.message === "product not found") {
        return rejectWithValue({
          backendProductErrors: {
            message: error.response.data.message
          }
        })
      }

      else if (error.response?.data.message === "something went wrong.") {
        return rejectWithValue({ serverError: "server error, try again later." });
      }

      else {
        return rejectWithValue({ unknownError: "An unknown error occurred." })
      }
    }
  }
)

export const searchProducts = createAsyncThunk(
  "product/searchProducts",
  async ({ query, page = 1, limit = 8 }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${baseUrl}/search-products`, {
        params: { query, page, limit }
      });

      return res.data;
    } catch (error) {

      if (!error.response) {
        return rejectWithValue({ networkError: "Network error. Please check your connection." })
      }
      if (!error.response?.data.message === "Search query is required.") {
        return rejectWithValue({
          backendProductErrors: {
            message: error.response.data.message
          }
        })
      }

      else if (error.response?.data.message === "Something went wrong.") {
        return rejectWithValue({ serverError: "server error, try again later." })
      }

      else {
        return rejectWithValue({ unknownError: "An unknown error occurred." });
      }

    }
  }
)